module.exports = __webpack_public_path__ + "img/traffic1.759b07e9.jpg";